var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 153,
    viewBox: "0 0 129 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0399 36.2093C83.0399 36.2093 83.2814 13.2767 77.2465 0C77.2465 0 12.0698 11.8284 0 18.8289C0 18.8289 10.8627 29.6917 14.2422 42.9684C17.8632 56.0037 82.5571 58.659 83.0399 36.2093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9712 52.8657C84.9712 52.8657 89.0749 11.1043 91.0061 2.41406C91.0061 2.41406 38.1406 6.75918 18.3462 18.1048L23.6569 62.2801L84.9712 52.8657Z",
    fill: "#F4C2C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.453 70.3972C145.453 70.3972 145.211 39.4985 153.66 24.7734C153.66 24.7734 103.933 25.739 92.8286 32.2567C81.7245 38.7744 83.1728 70.1558 83.1728 70.1558C83.1728 70.1558 143.28 73.7767 145.453 70.3972Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.493 63.9316H96.6963V214.804H151.493V63.9316Z",
    fill: "#6DAFA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2439 222.809V36.2109L9.41406 44.177V203.256L42.2439 222.809Z",
    fill: "#6DAFA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0407 36.2109H42.2441V222.809H97.0407V36.2109Z",
    fill: "#FFE779"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2446 150.391H83.0394",
    stroke: "#22272E",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon2);
export default __webpack_public_path__ + "static/media/cardIcon2.0914d31efc06cf76c69c01015dd0c440.svg";
export { ForwardRef as ReactComponent };